import { Sunrise, Shirt, ParkingSquare, Phone } from "lucide-react";

// Hardcoded per-event content — hero image, write-up, logistics, and
// downloadable social templates. Keyed the same way `event.event_key`
// is used everywhere else in this app.
//
// To make this admin-editable later: replace the body of getEventContent()
// with a Supabase fetch (e.g. an `event_content` table keyed by event_id)
// that returns this same shape. Nothing else in VendorEventWorkspace needs
// to change — it only ever calls getEventContent(eventKey).
export const EVENT_CONTENT = {
  "66489b2f-1fa8-4307-a57d-d62a60dba217": {
    heroImage: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205",
    tagline: "Where Cultures Connect.",
    description:
      "Global Village brings together makers, food vendors, and brands from across the region for a weekend " +
      "of trade, culture, and community. Expect high foot traffic, a curated layout by category, and a crowd " +
      "that comes ready to buy. This is your space to make an impression — bring your best presentation.",
    logistics: [
      { icon: Sunrise, label: "Set-up", value: "Friday 25th Sep 10AM - 5PM " },
      { icon: ParkingSquare, label: "Parking", value: "Available. No Exclusive Vendor Parking unles prior arrangements are made." },
      { icon: Phone, label: "On-site contact", value: "+254 701 395 902 " },
    ],
    socialTemplates: [
      { label: "Instagram square", ratio: "1:1", imageUrl: "/assets/social/gv2026-square.png" },
      { label: "Instagram story", ratio: "9:16", imageUrl: "/assets/social/gv2026-story.png" },
      { label: "Facebook post", ratio: "4:5", imageUrl: "/assets/social/gv2026-facebook.png" },
    ],
  },
};

export const DEFAULT_EVENT_CONTENT = {
  heroImage: null,
  tagline: "",
  description: "Event details will be added soon — check back closer to the date.",
  logistics: [],
  socialTemplates: [],
};

export function getEventContent(eventKey) {
  return EVENT_CONTENT[eventKey] || DEFAULT_EVENT_CONTENT;
}

export function getDaysUntil(dateString) {
  if (!dateString) return null;
  const now = new Date();
  const target = new Date(dateString);
  const diffMs = target.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0);
  return Math.round(diffMs / 86400000);
}